export async function getCalendarData(url, query) {
  let newQuery = {
    locations: '',
    category: '',
    sport: '',
    activity: '',
    gender: '',
    age: '',
    organization: ''
  }

  if (query.location) newQuery.locations = query.location
  if (query.category) newQuery.category = query.category
  if (query.sport) newQuery.sport = query.sport
  if (query.activity) newQuery.activity = query.activity
  if (query.gender) newQuery.gender = query.gender
  if (query.age) newQuery.age = query.age
  if (query.organization) newQuery.organization = query.organization

  try {
    const { data } = await axios.get(url, { params: newQuery }) // eslint-disable-line
    return [null, data]
  } catch (error) {
    return [error]
  }
}

export async function getFilteredCalendarData(url, query) {
  let newQuery = {
    keywords: '',
    'start-date': '',
    sort: '',
    page: 1,
    locations: '',
    category: '',
    activity: '',
    gender: '',
    age: '',
    sport: '',
    organization: ''
  }

  if (query.search) newQuery.keywords = query.search
  if (query.startDate) newQuery['start-date'] = query.startDate
  if (query.sort) newQuery.sort = query.sort
  if (query.page) newQuery.page = query.page + 1
  if ((query.location || []).length > 0) newQuery.locations = query.location.join(',')
  if ((query.category || []).length > 0) newQuery.category = query.category.join(',')
  if ((query.activity || []).length > 0) newQuery.activity = query.activity.join(',')
  if ((query.gender || []).length > 0) newQuery.gender = query.gender.join(',')
  if ((query.age || []).length > 0) newQuery.age = query.age.join(',')
  if ((query.sport || []).length > 0) newQuery.sport = query.sport.join(',')
  if ((query.organization || []).length > 0) newQuery.organization = query.organization

  try {
    const { data } = await axios.get(url, { params: newQuery }) // eslint-disable-line
    return [null, data]
  } catch (error) {
    return [error]
  }
}

// Schedules API functionality

export async function getSchedulesData(url, query) {
  try {
    const { data } = await axios.get(url, { params: query }) // eslint-disable-line
    return [null, data]
  } catch (error) {
    return [error]
  }
}

export async function getFilteredSchedulesData(url, query) {
  let newQuery = {
    date: '',
    page: 1,
    locations: '',
    categories: '',
    organization: ''
  }

  if (query.date) newQuery.date = query.date
  if (query.page) newQuery.page = query.page + 1
  if ((query.location || []).length > 0) newQuery.locations = query.location.join(',')
  if ((query.categories || []).length > 0) newQuery.categories = query.categories.join(',')
  if ((query.organization || []).length > 0) newQuery.organization = query.organization

  try {
    const { data } = await axios.get(url, { params: newQuery }) // eslint-disable-line
    return [null, data]
  } catch (error) {
    return [error]
  }
}
